import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { requestOTP, ValidateOTP } from './module';

const initialState = {
    mySession: null,
    OTPKey: null,
    countdownNo: 60,
    isRequestedOtp: false,
    disableBtn: false,
    status: "idle",
    ActionStatus: "",
    errorMessage: ""
};


export const requestOTPAsync = createAsyncThunk(
    'otp/requestOTP',
    async (data, ThunkAPI) => {
        const response = await requestOTP(data);
        return response;
    }
);

export const resendOTPAsync = createAsyncThunk(
    'otp/resendOTP',
    async (data, ThunkAPI) => {
        const response = await requestOTP(data);
        return response;
    }
);

export const ValidateOTPAsync = createAsyncThunk(
    'otp/validateOTP',
    async (data, ThunkAPI) => {
        const response = await ValidateOTP(data);
        return response;
    }
);

export const otpSlice = createSlice({
    name: 'otp',
    initialState,
    reducers: {
        clearAction: (state, action) => {
            state.isRequestedOtp = null;
        },
        ChangeCountdownNumber: (state, action) => {
            state.countdownNo = action.payload;
        },
        triggerDisableBtn: (state, action) => {
            state.disableBtn = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(requestOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(requestOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(requestOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.isRequestedOtp = true;
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(resendOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(resendOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(resendOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(ValidateOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(ValidateOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(ValidateOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            console.log("action.payload",action.payload)
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            } else {
                sessionStorage.removeItem('ue');  
                sessionStorage.removeItem('up');
                window.location.href="./requests";
            }
        });


    }
});

export const { clearAction, triggerDisableBtn, ChangeCountdownNumber } = otpSlice.actions;
export const pagesState = (state) => state.otp;
export const mySession = (state) => state.Session.mySession;

export default otpSlice.reducer;
